<template>
  <div class="dashboard-phase5" v-loading="loading">
    <el-alert
      v-if="error"
      :title="error"
      type="warning"
      :closable="false"
      show-icon
      class="page-alert"
    />

    <AnalysisDataStatusPanel
      :payload="payload"
      :loading="loading"
      title="系统分析数据健康"
      subtitle="首页只回答“现在能不能分析”。结论留痕、任务、运行记录、第一本账、模拟账户等稳定功能继续从各自页面查看。"
      :show-items="false"
      @refresh="refreshData"
    />

    <div class="section-title">常用入口</div>
    <div class="entry-grid">
      <el-card
        v-for="entry in entries"
        :key="entry.path"
        shadow="hover"
        class="entry-card"
        @click.native="go(entry.path)"
      >
        <div class="entry-icon"><i :class="entry.icon"></i></div>
        <div>
          <strong>{{ entry.title }}</strong>
          <p>{{ entry.desc }}</p>
        </div>
        <i class="el-icon-arrow-right entry-arrow"></i>
      </el-card>
    </div>

    <el-card shadow="never" class="note-card">
      <div slot="header" class="note-title">数据口径说明</div>
      <div class="note-grid">
        <div><strong>日线</strong><span>长期分析基础数据。</span></div>
        <div><strong>周 / 月</strong><span>由日线和官方交易日历自动生成。</span></div>
        <div><strong>5分钟</strong><span>分钟级热数据基础。</span></div>
        <div><strong>15分钟 / 60分钟</strong><span>由5分钟数据自动生成。</span></div>
      </div>
    </el-card>
  </div>
</template>

<script>
import AnalysisDataStatusPanel from '@/components/AnalysisDataStatusPanel.vue'
import dashboardV2Api from '@/api/dashboardV2'

export default {
  name: 'DashboardPhase5',
  components: { AnalysisDataStatusPanel },
  data() {
    return {
      loading: false,
      error: '',
      payload: {},
      entries: [
        { path: '/first-book', title: '第一本账', desc: '查看正式区、临时区、每日复核与分析数据状态。', icon: 'el-icon-notebook-2' },
        { path: '/core-index-history', title: '核心指数', desc: '查看固定 7 个核心指数的分析数据状态。', icon: 'el-icon-data-analysis' },
        { path: '/scheduled-tasks', title: '任务监控', desc: '查看固定任务是否启用、计划时间和最近结果。', icon: 'el-icon-timer' },
        { path: '/scheduled-task-runs', title: '运行记录', desc: '查看任务结果、通知状态、失败说明与完整编号。', icon: 'el-icon-document' },
        { path: '/conclusions', title: '结论留痕', desc: '查看分析结论、验证结果与摘要/高级留痕回执。', icon: 'el-icon-document-checked' },
        { path: '/simulation-account', title: '模拟账户', desc: '查看模拟资金、持仓、交易记录和绩效。', icon: 'el-icon-wallet' },
        { path: '/history-monitor', title: '数据健康', desc: '查看更完整的分析与行情数据健康明细。', icon: 'el-icon-monitor' }
      ]
    }
  },
  mounted() { this.refreshData() },
  methods: {
    async refreshData() {
      this.loading = true
      this.error = ''
      try {
        this.payload = await dashboardV2Api.getAnalysisDataStatus()
      } catch (error) {
        this.payload = {}
        const detail = error && error.response && error.response.data && error.response.data.detail
        this.error = detail || (error && error.message) || '首页分析数据状态暂不可确认'
      } finally {
        this.loading = false
      }
    },
    go(path) {
      this.$router.push({ path }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.dashboard-phase5 { max-width: 1480px; margin: 0 auto; }
.page-alert { margin-bottom: 14px; }
.section-title { margin: 20px 2px 10px; color: #334155; font-size: 15px; font-weight: 700; }
.entry-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.entry-card { border-radius: 16px; cursor: pointer; border-color: #e1e8f0; }
.entry-card /deep/ .el-card__body { display: grid; grid-template-columns: 44px 1fr 20px; gap: 12px; align-items: center; padding: 16px; }
.entry-icon { width: 42px; height: 42px; border-radius: 13px; display: flex; align-items: center; justify-content: center; background: #eef5ff; color: #2563eb; font-size: 20px; }
.entry-card strong { color: #0f172a; }
.entry-card p { margin: 5px 0 0; color: #7b8798; font-size: 12px; line-height: 1.5; }
.entry-arrow { color: #94a3b8; }
.note-card { margin-top: 16px; border-radius: 16px; border-color: #dfe7f2; }
.note-title { color: #1f2937; font-size: 15px; font-weight: 700; }
.note-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; }
.note-grid div { padding: 12px; border-radius: 12px; background: #f8fbff; }
.note-grid strong { display: block; color: #0f172a; }
.note-grid span { display: block; margin-top: 5px; color: #64748b; font-size: 12px; }
@media (max-width: 1050px) {
  .entry-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .note-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
</style>